import { render, staticRenderFns } from "./FSwitch.vue?vue&type=template&id=3ce967b5&"
import script from "./FSwitch.vue?vue&type=script&lang=js&"
export * from "./FSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports